import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { cleanInput } from "../../../../helpers/cleanInput";
import Location from "../../../../components/includes/location";
import PersonalDetails from "./personalDetails";
import ShippersRate1 from "./shippersRate1";
import ShippersRate2 from "./shippersRate2";
import {
  editShipper,
  showShipper,
} from "../../../../redux/shippers/shippersActions";

export default function EditShipper() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const { shipper } = useSelector((state) => state.shipper);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });

  const fromJson = (value) => JSON.parse(value);

  let [phone, setPhone] = useState("");
  const [data, setData] = useState({
    currency: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    insurance_percentage: "",
    tax_percentage: "",
    discount_percentage: "",
    vat_percentage: "",
    base_fee: "",
    base_fee_per_meter: "",
    base_fee_per_kilogram: [],
    base_fees_by_delivery_mode: [],
    weight_limit_by_kilogram: "",
    base_fees_per_meter_by_range: [],
    base_url: "",
    contractor: "",
    token: "",
  });
  // const {
  //   address,
  //   currency,
  //   city,
  //   state,
  //   country,
  //   zip,
  //   insurance_percentage,
  //   base_fee_per_meter,
  //   tax_percentage,
  //   discount_percentage,
  //   base_fee,
  //   base_fees_by_delivery_mode,
  //   base_fee_per_kilogram,
  //   weight_limit_by_kilogram,
  //   base_url,
  //   contractor,
  // } = data;

  useEffect(() => {
    if (id) {
      dispatch(showShipper(id));
    }
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    setData({
      address: shipper?.address,
      currency: shipper?.currency,
      city: shipper?.city,
      state: shipper?.state,
      country: shipper?.country,
      zip: shipper?.zip,
      insurance_percentage: Math.trunc(shipper?.insurance_percentage),
      base_fee_per_meter: shipper?.base_fee_per_meter,
      tax_percentage: Math.trunc(shipper?.tax_percentage),
      discount_percentage: Math.trunc(shipper?.discount_percentage),
      vat_percentage: Math.trunc(shipper?.vat_percentage),
      base_fee: shipper?.base_fee,
      base_fees_by_delivery_mode: shipper?.base_fees_by_delivery_mode,
      base_fee_per_kilogram: shipper?.base_fee_per_kilogram,
      weight_limit_by_kilogram: shipper?.weight_limit_by_kilogram,
      base_fees_per_meter_by_range: shipper?.base_fees_per_meter_by_range ?? [],
      base_url: shipper?.base_url,
      contractor: shipper?.contractor,
      token: shipper?.token,
    });
    setPhone(shipper?.phone);
  }, [shipper]);

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async () => {
    // cleanInput(data);
    setSubmitted(true);

    if (
      // currency &&
      // insurance_percentage &&
      phone
      // base_fee_per_meter &&
      // address &&
      // city &&
      // state &&
      // country &&
      // base_fees_by_delivery_mode &&
      // base_fee_per_meter &&
      // base_fee_per_kilogram &&
      // zip &&
      // weight_limit_by_kilogram
    ) {
      cleanInput(data);

      // The phone input adds a leading + once edited, but the backend stores
      // numbers without it. An unedited number has none, so don't use slice(1).
      const response = await dispatch(
        editShipper({ ...data, id: id, phone: phone.replace(/^\+/, "") }),
      );
      if (response) {
        navigate("/admin/shippers/unapproved/1");
      }
    }
  };

  return (
    <>
      <div className="py-4 sm:pt-2 sm:flex items-center mx-auto w-full">
        <div className="w-full">
          <PersonalDetails
            handleChange={handleChange}
            data={data}
            phone={phone}
            setPhone={setPhone}
            submitted={submitted}
            Location={Location}
            locationId={locationId}
            locationList={locationList}
            setLocationList={setLocationList}
            setLocationId={setLocationId}
            handleRegion={handleRegion}
            handleSubmit={handleSubmit}
          />
          <div className="grid sm:grid-cols-2 gap-5 mt-8">
            <ShippersRate1
              handleChange={handleChange}
              data={data}
              setData={setData}
              submitted={submitted}
            />
            <ShippersRate2
              handleChange={handleChange}
              data={data}
              setData={setData}
              handleSubmit={handleSubmit}
              submitted={submitted}
            />
          </div>
        </div>
      </div>
    </>
  );
}
